import { Collapse } from "@mui/material";
import { Team } from "certiblok-api-manager";
import { useFormContext } from "react-hook-form";
import { EditCreateFolderFormValues } from "../hooks/useEditCreateFolderZodSchema";
import TeamInFolder from "./TeamInFolder";
import { TransitionGroup } from "react-transition-group";

type FilteredTeamsListProps = {
	filterValue: string;
	isParentRestricted: boolean;
	parentTeams?: Team[];
};

export const FilteredTeamsList = ({ filterValue, isParentRestricted, parentTeams }: FilteredTeamsListProps) => {
	const { watch, setValue } = useFormContext<EditCreateFolderFormValues>();
	const reservedToTeams = watch("reservedToTeams");

	const teamsToShow = isParentRestricted
		? (parentTeams ?? []).filter((team) => team.name.toLowerCase().includes(filterValue.toLowerCase()))
		: reservedToTeams;

	return (
		<TransitionGroup>
			{teamsToShow.map((team) => {
				if (team.isNew) {
					return null;
				}
				const isExcludedFromParent = isParentRestricted && reservedToTeams.findIndex((t) => t.id === team.id) === -1;
				return (
					<Collapse key={team?.id}>
						<TeamInFolder
							team={team}
							endIcon={isParentRestricted ? "eye" : "delete"}
							onEndIconClick={() => {
								if (!isExcludedFromParent || !isParentRestricted) {
									setValue(
										"reservedToTeams",
										reservedToTeams.filter((selectedGroup) => selectedGroup.id !== team.id)
									);
								} else {
									setValue("reservedToTeams", [...reservedToTeams, team]);
								}
							}}
							sx={{
								marginTop: 1,
							}}
							excludedFromParent={isExcludedFromParent}
						/>
					</Collapse>
				);
			})}
		</TransitionGroup>
	);
};
